const cmpVendorIDs = {
  YOUTUBE: { id: 's30', name: 'Google Ireland Ltd. (YouTube)' },
  GRECAPTCHA: { id: 's1409', name: 'Google LLC (reCAPTCHA)' },
  GOOGLEMAPS: { id: 's1104', name: 'Google Ireland Ltd. (Google Maps)' },
  MICROSOFT_LIVE_CHAT: { id: 's1050', name: 'Microsoft Corporation (Omnichannel Live Chat)' } // Add Microsoft Live Chat
}

export default cmpVendorIDs
